/* AMUX theme — global JS: cart drawer + AJAX, menu, sticky header */
(function () {
  "use strict";

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var fmt = format || window.moneyFormat || "${{amount}}";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";
      var number = (parseInt(cents, 10) / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
      var cents_ = parts[1] ? decimal + parts[1] : "";
      return dollars + cents_;
    }
    switch (fmt.match(placeholderRegex)[1]) {
      case "amount": value = num(cents, 2); break;
      case "amount_no_decimals": value = num(cents, 0); break;
      case "amount_with_comma_separator": value = num(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = num(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = num(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = num(cents, 0, " ", ""); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  /* ---------- BGN dual display (Bulgaria euro changeover) ---------- */
  var BGN = window.AMUX_BGN || { show: true, rate: 1.95583, suffix: "\u043b\u0432." };
  function formatBGN(cents) {
    var v = Math.round(Math.abs(parseInt(cents, 10) || 0) * BGN.rate);
    var whole = Math.floor(v / 100);
    var frac = v % 100;
    return (cents < 0 ? "-" : "") + whole + "," + (frac < 10 ? "0" : "") + frac + "\u00a0" + (BGN.suffix || "\u043b\u0432.");
  }
  function bgnHTML(cents) {
    if (!BGN.show) return "";
    return '<span class="price-bgn" lang="bg">' + formatBGN(cents) + "</span>";
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- sticky header + announcement coordination ---------- */
  var header = $("[data-header]");
  var announcement = $("[data-announcement]");
  function setAnnHeight() {
    var h = announcement ? announcement.offsetHeight : 0;
    document.documentElement.style.setProperty("--ann-h", h + "px");
  }
  setAnnHeight();
  window.addEventListener("resize", setAnnHeight, { passive: true });
  if (header || announcement) {
    var lastScrolled = null;
    var onScroll = function () {
      var s = window.scrollY > 24;
      if (s !== lastScrolled) {
        lastScrolled = s;
        document.body.classList.toggle("is-scrolled", s);
        if (header) header.classList.toggle("hdr--solid", s);
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  var burger = $("[data-menu-toggle]");
  var sheet = $("[data-menu-sheet]");
  function lockScroll(on) {
    document.documentElement.classList.toggle("nav-open", on);
    document.body.classList.toggle("nav-open", on);
  }
  function closeMenu() {
    if (!sheet) return;
    sheet.classList.remove("is-open");
    if (burger) { burger.setAttribute("aria-expanded", "false"); burger.classList.remove("is-open"); }
    lockScroll(false);
  }
  if (burger && sheet) {
    burger.addEventListener("click", function () {
      var open = sheet.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      burger.classList.toggle("is-open", open);
      lockScroll(open);
    });
    $$(".hdr__sheet-link", sheet).forEach(function (l) {
      l.addEventListener("click", closeMenu);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $("[data-cart-drawer]");
  var scrim = $("[data-cart-scrim]");
  var useDrawer = drawer != null;

  function openDrawer() {
    if (!useDrawer) return;
    drawer.classList.add("in");
    scrim.classList.add("in");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow-hidden");
  }
  function closeDrawer() {
    if (!useDrawer) return;
    drawer.classList.remove("in");
    scrim.classList.remove("in");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");
  }
  if (useDrawer) {
    $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
    if (scrim) scrim.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });
    // open from header cart icon
    $$("[data-cart-toggle]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
    });
  }

  /* ---------- cart count bubbles ---------- */
  function setCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.classList.toggle("is-empty", n === 0);
    });
  }

  /* ---------- render drawer from cart.js JSON ---------- */
  var I18N = window.AMUX_I18N || {};
  function t(k, fb) { return I18N[k] || fb; }
  function renderDrawer(cart) {
    setCount(cart.item_count);
    if (!useDrawer) return;
    var items = $("[data-cart-items]", drawer);
    var foot = $("[data-cart-foot]", drawer);
    if (cart.item_count === 0) {
      items.innerHTML =
        '<div class="drawer__empty"><p class="mono-label">' + t("empty", "Your cart is empty") + "</p>" +
        '<a class="btn btn--ghost btn--sm" href="' + t("all_products", "/collections/all") + '">' + t("continue", "Continue shopping") + "</a></div>";
      if (foot) foot.setAttribute("hidden", "");
    } else {
      var html = "";
      cart.items.forEach(function (item) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="" width="78">'
          : '<div class="ph"></div>';
        var variant = item.variant_title ? '<p class="ci__var mono-label">' + item.variant_title + "</p>" : "";
        // line-level discounts (kit/auto discounts): tag per allocation + strike-through original
        var tags = "";
        (item.line_level_discount_allocations || []).forEach(function (a) {
          var title = (a.discount_application && a.discount_application.title) || t("discount", "Discount");
          tags += '<span class="ci__tag mono-label">' + title + " \u2212" + formatMoney(a.amount) + "</span>";
        });
        if (tags) tags = '<div class="ci__tags">' + tags + "</div>";
        var was = item.original_line_price > item.final_line_price
          ? '<s class="ci__was">' + formatMoney(item.original_line_price) + "</s>"
          : "";
        html +=
          '<div class="ci" data-line-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="ci__media">' + img + "</a>" +
          '<div class="ci__body"><div class="ci__top"><h4>' + item.product_title + "</h4>" +
          '<button class="ci__rm" data-line-remove aria-label="' + t("remove", "Remove") + '">&times;</button></div>' +
          variant + tags +
          '<div class="ci__bottom"><div class="qty">' +
          '<button data-qty-down aria-label="Decrease">&ndash;</button>' +
          '<span data-qty>' + item.quantity + "</span>" +
          '<button data-qty-up aria-label="Increase">+</button></div>' +
          '<span class="ci__price">' + was + formatMoney(item.final_line_price) + bgnHTML(item.final_line_price) + "</span></div></div></div>";
      });
      items.innerHTML = html;
      if (foot) foot.removeAttribute("hidden");
      var sub = $("[data-cart-subtotal]", drawer);
      if (sub) sub.innerHTML = formatMoney(cart.total_price) + bgnHTML(cart.total_price);
      // cart-level discount rows (e.g. codes applied to the whole cart)
      var discWrap = $("[data-cart-discounts]", drawer);
      if (discWrap) {
        var dhtml = "";
        (cart.cart_level_discount_applications || []).forEach(function (a) {
          dhtml += '<div class="drawer__disc mono-label"><span>' + t("discount", "Discount") + " &middot; " + a.title + "</span><span>\u2212" + formatMoney(a.total_allocated_amount) + "</span></div>";
        });
        discWrap.innerHTML = dhtml;
      }
      // total-explicit checkout CTA
      var ctot = $("[data-checkout-total]", drawer);
      if (ctot) ctot.textContent = formatMoney(cart.total_price);
    }
    // free shipping bar
    var bar = $("[data-ship-bar]", drawer);
    if (bar) {
      var threshold = parseInt(bar.getAttribute("data-threshold"), 10) || 0;
      var remaining = threshold - cart.total_price;
      var pct = threshold > 0 ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
      var msg = $("[data-ship-msg]", bar);
      var fill = $("[data-ship-fill]", bar);
      if (msg) msg.innerHTML = remaining > 0
        ? t("ship_remaining", "You\u2019re [amount] from free delivery").replace("[amount]", "<b>" + formatMoney(remaining) + "</b>")
        : t("ship_unlocked", "Free delivery unlocked");
      if (fill) fill.style.width = pct + "%";
    }
  }

  function fetchCart() {
    return fetch(window.routes.cart_url + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderDrawer);
  }

  /* ---------- add to cart ---------- */
  function addToCart(form, button) {
    var data = new FormData(form);
    // Guard: never submit without a resolved variant id (prevents adding the wrong item)
    var vid = data.get("id");
    if (!vid) {
      var err0 = $("[data-cart-error]", form);
      var pickLabel = $("[data-add-text]", form);
      if (err0) err0.textContent = (pickLabel && pickLabel.textContent.trim()) || "Please choose the options first.";
      return Promise.resolve();
    }
    if (button) { button.classList.add("is-loading"); button.setAttribute("disabled", ""); }
    return fetch(window.routes.cart_add_url + ".js", {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var err = $("[data-cart-error]", form);
          if (err) err.textContent = res.body.description || res.body.message || "Could not add to cart.";
          return;
        }
        return fetchCart().then(openDrawer);
      })
      .catch(function () {})
      .finally(function () {
        if (button) { button.classList.remove("is-loading"); button.removeAttribute("disabled"); }
      });
  }

  // intercept quick-add + main product forms (detected by their cart/add action)
  document.addEventListener("submit", function (e) {
    var form = e.target;
    var action = (form.getAttribute("action") || "");
    var isCartForm = form.classList.contains("pdp__form") ||
      form.classList.contains("pcard__form") ||
      action.indexOf("/cart/add") !== -1;
    if (isCartForm) {
      e.preventDefault();
      addToCart(form, $("[data-add-button]", form) || $('button[type="submit"]', form));
    }
  });

  /* ---------- qty change + remove (delegated) ---------- */
  function changeLine(key, quantity) {
    return fetch(window.routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderDrawer);
  }

  if (useDrawer) {
    drawer.addEventListener("click", function (e) {
      var row = e.target.closest("[data-line-key]");
      if (!row) return;
      var key = row.getAttribute("data-line-key");
      var qtyEl = $("[data-qty]", row);
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest("[data-qty-up]")) changeLine(key, qty + 1);
      else if (e.target.closest("[data-qty-down]")) changeLine(key, Math.max(0, qty - 1));
      else if (e.target.closest("[data-line-remove]")) changeLine(key, 0);
    });
  }

  // expose
  window.AMUX = { openDrawer: openDrawer, closeDrawer: closeDrawer, fetchCart: fetchCart, formatMoney: formatMoney, formatBGN: formatBGN, bgnHTML: bgnHTML };
})();
